<template>
  <el-row :gutter="20">
    <el-col :span="6">
      <el-card class="card">
        <i class="card__icon fa fa-ticket"></i>
        <h1 class="card__title">Liczba kodów</h1>
        <p><strong>Wszystkie: </strong> {{ contentCounters.codes_all }}</p>
        <p><strong>Wykorzystane: </strong> {{ contentCounters.codes_used }}</p>
        <p><strong>Wolne: </strong> {{ contentCounters.codes_free }}</p>
      </el-card>
    </el-col>
    <el-col :span="6">
      <el-card class="card">
        <i class="card__icon el-icon-user"></i>
        <h1 class="card__title">Liczba użytkowników</h1>
        {{ contentCounters.users }}
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    contentCounters: Object
  }
}
</script>

<style lang="scss" scoped>
.card {
  &__title {
    font-size: 20px;
  }

  &__icon {
    font-size: 64px;
    color: $text-color;
    display: block;
  }
}
</style>
